import classNames from "classnames";
import { FC, memo } from "react";

import styles from "./style.module.scss";

export type TagTone = "green" | "orange" | "red" | "violet" | "blue" | "gray";

type PropTypes = {
  tone: TagTone;
  children: React.ReactNode;
  className?: string;
};

const Tag: FC<PropTypes> = ({ tone, children, className }) => {
  return <span className={classNames(styles.tag, styles[tone], className)}>{children}</span>;
};

export default memo(Tag);
